import moment from 'moment';
import { IListColumn } from '~/models/listCol';
import { cpfMask } from '~/utils/masks';

export const HeaderBillingOdonto = [
  {
    id: 1,
    value: 'Nome completo',
    maxChar: 20,
  },
  {
    id: 2,
    value: 'CPF',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 3,
    value: 'Vencimento',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 4,
    value: 'Status Fatura',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 5,
    value: 'Data de Adesão',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 6,
    value: 'Data de Pagamento',
    maxChar: 15,
    textAlign: 'center',
  },
];

export const BodyBillingOdonto = (data: any) => {
  // let x = 0;

  const items = [];

  data.pagina?.forEach((i) => {
    const item: IListColumn[] = [
      // {
      //   type: 'id',
      //   value: x++,
      //   maxChar: 5,
      // },
      {
        value: i.nome,
        maxChar: 20,
      },
      {
        value: cpfMask(i.cpf).masked,
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: i.vencimento ? moment(i.vencimento).format('DD/MM/YYYY') : '-',
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: i.status,
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: i.dataAdesao ? moment(i.dataAdesao).format('DD/MM/YYYY') : '-',
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: i.dataPagamento
          ? moment(i.dataPagamento).format('DD/MM/YYYY')
          : '-',
        maxChar: 15,
        textAlign: 'center',
      },
    ];
    items.push(item);
  });
  return items;
};
